import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const Group = styled.div`
  width: 100%;
  min-height: 560px;
  height: 100dvh;
  background-color: var(--background-secondary);
  margin: auto;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mobile_xl(css`
    min-height: 781px;
  `)}
`;

const Content = styled.form`
  width: 100%;
  max-width: 558px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--background-secondary);
  gap: 20px;
  ${mobile_xl(css`
    gap: 30px;
    max-width: 100%;
    padding: 30px 16px;
  `)}
`;

const Icon = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${mobile_xl(css`
    .svgIcon {
      width: 40px;
      height: 40px;
    }
  `)}
`;

const Title = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: 0;
  ${mobile_xl(css`
    text-align: center;
  `)}
`;

const FormBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-card-hover);
  border-radius: var(--border-radius-8);
  padding: 20px;
  ${mobile_xl(css`
    padding: 18px;
    gap: 30px;
  `)}
`;

const Profile = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
  ${mobile_xl(css`
    margin-top: 16px;
  `)}
`;

const Heading = styled.h2`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: 0;
`;

const Text = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: 0;

  ${mobile_xl(css`
    text-align: center;
  `)}
`;

const SubBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${mobile_xl(css`
    gap: 20px;
  `)}
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  .angleDown-icon {
    path {
      stroke: var(--text-secondary);
    }
  }
`;

const Label = styled.label`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
`;

const InputValue = styled.input`
  ${Typography.body_lg_medium}
  background-color: var(--background-primary);
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  padding: 7px 12px;
  border-radius: var(--border-radius-6);
  outline: none;
  :focus {
    border: 0.5px solid var(--brand-primary);
  }
  ::placeholder {
    ${Typography.body_lg_medium}
    color:  var(--text-placeholder);
  }
  ${mobile_xl(css`
    padding: 12px;
  `)}
`;

const Endblock = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  ${mobile_xl(css`
    flex-direction: column;
    gap: 30px;
  `)}
`;

const TextFormat = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: 0;
`;

const FormContent = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${mobile_xl(css`
    gap: 20px;
  `)}
`;

const ProfileView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  ${mobile_xl(css`
    gap: 8px;
  `)}
`;

const ProfileContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const InputDiv = styled.div`
  position: relative;
  cursor: pointer;
`;
const Input = styled.input`
  min-width: 414px;
  padding: 7px 12px;
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-6);
  cursor: pointer;
  ${Typography.body_lg}
  ::placeholder {
    color: var(--text-secondary);
  }
  :focus-visible {
    border-color: var(--brand-primary);
    outline: unset;
  }
  ${mobile_xl(css`
    min-width: calc(100vw - 90px);
  `)}
`;

const IconDiv = styled.div`
  position: absolute;
  top: 8px;
  right: 10px;
  .angleDown-icon {
    transition: transform 0.3s ease;
  }

  .angleDown-icon.rotate {
    transform: rotate(180deg);
  }
`;

const ItemDiv = styled.div`
  max-height: 140px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-right: 4px;
  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--text-placeholder);
    border-radius: var(--border-radius-12);
    min-height: 28px;
  }
`;
export {
  Group,
  Content,
  Icon,
  Title,
  FormBlock,
  Profile,
  Heading,
  Text,
  SubBlock,
  Item,
  Label,
  InputValue,
  Endblock,
  TextFormat,
  FormContent,
  ProfileView,
  ProfileContent,
  InputDiv,
  Input,
  IconDiv,
  ItemDiv
};
